import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { MD5UtilService } from './MD5Util.service';
@Injectable({
  providedIn: 'root'
})
export class RechargeService {

  constructor(private http: HttpClient,private md5Util:MD5UtilService) { }

  rechargeMobile(params: any, type: string,selectedLoc,selectedoperator,userCurrenPosition) {
    console.log(userCurrenPosition);
    var md5key=localStorage.getItem('md5key');
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
    var token = localStorage.getItem('wallet-token');
    const checksum = selectedLoc+selectedoperator+params.amount+params.mobile_no+md5key;
    let headers = new HttpHeaders();
    headers = headers.append('authToken', token);
    headers = headers.append('checksum', this.md5Util.getMd5Checksum(checksum).toString());
    headers = headers.append('apikey', environment.api_key);
    if(userCurrenPosition==undefined){
      alert("Please enable your location before proceed");
      return;
 
    }else{
      var reqParam = {
        amount: params.amount,
        comments: 'Mobile Recharge',
        latitute: userCurrenPosition.latitude,
        longitute: userCurrenPosition.longitude,
        'rechargeDetails': {
          location: selectedLoc,
          mobileNumber: params.mobile_no,
          mobileOperator: selectedoperator,
          postpaidorprepaid: type == 'prepaid' ? 'N' : 'Y'
        }

      
      }
      console.log(reqParam);
      return this.http.post(`${environment.walletUrl}/ym/retailor/v2/rechageMobile`, reqParam, { headers: headers });
    
    }
      
    

  }
  rechargeDTH(params: any,userCurrenPosition=null){
    var md5key=localStorage.getItem('md5key');
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
    var token = localStorage.getItem('wallet-token');
    const checksum = params.dthoperator+params.dthrechargeamount+params.customer_Id+md5key;

    let headers = new HttpHeaders();
    headers = headers.append('authToken', token);
    headers = headers.append('checksum', this.md5Util.getMd5Checksum(checksum).toString());
    headers = headers.append('apikey', environment.api_key);
   
    const reqParam = {
    
      amount: params.dthrechargeamount,
      comments: "DTH Recharge",
      latitute: userCurrenPosition.latitude,
      longitute: userCurrenPosition.longitude,
      
      dthdetails: {
        dthNumber: params.customer_Id,
        dthOperator: params.dthoperator
      }

    }
   
    
  
    return this.http.post(`${environment.walletUrl}/ym/retailor/v2/rechagedth`, reqParam, { headers: headers });

  }

  
  getMobileOpetators() {
    let headers = new HttpHeaders();
    headers = headers.append('apikey', environment.api_key);
  
    return this.http.get(`${environment.baseUrl}/v1/api/getall/mobileoperator`,{ headers: headers });
  }
  getdthOperators() {
    let headers = new HttpHeaders();
    headers = headers.append('apikey', environment.api_key);
  
    return this.http.get(`${environment.baseUrl}/v1/api/getall/dthoperator`,{ headers: headers });
  }
  dataOperators() {
    let headers = new HttpHeaders();
    headers = headers.append('apikey', environment.api_key);
  
    return this.http.get(`${environment.baseUrl}/v1/api/getall/datacard`,{ headers: headers });
  }
  getAllLocations() {
    let headers = new HttpHeaders();
    headers = headers.append('apikey', environment.api_key);
  
    return this.http.get(`${environment.baseUrl}/v1/api/getall/location`,{ headers: headers });
  }
  
  getMobileDetails(mobno) {
    // GET /v1/ym/retailor/get/mobilenumber/details
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
    var token = localStorage.getItem('wallet-token');
    let headers = new HttpHeaders();
    headers = headers.append('authToken', token);
    headers = headers.append('apikey', environment.api_key);
   
    return this.http.get(`${environment.baseUrl}/v1/ym/retailor/get/mobilenumber/details?mobileNumber=${mobno}`,{headers:headers});
  }

  browsePlans(params) {
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
    var token = localStorage.getItem('wallet-token');
    let headers = new HttpHeaders();
    headers = headers.append('authToken', token);
    headers = headers.append('apikey', environment.api_key);
   
   
    return this.http.get(`${environment.baseUrl}/v1/ym/retailor/get/plan/details?serviceName=${params.serviceName}&serviceProviderName=${params.serviceProviderName}&locationName=${params.locationName}`,{headers:headers});
  }
 
  movetobank(value,transactiontype,userCurrenPosition) {
    // let agentId = JSON.parse(localStorage.getItem('currentUser')).data.agentId;
    console.log(value);
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
    var token = localStorage.getItem('wallet-token');
    var md5key=localStorage.getItem('md5key');
    console.log("md5key:::::::::",md5key)
    var checkSum = this.md5Util.getMd5Checksum(value.amount+value.comments+md5key);

    console.log("checkSum::::::::::",checkSum);

    let headers = new HttpHeaders();
    headers = headers.append('authToken', token);
    headers = headers.append('checkSum',checkSum.toString());
    headers = headers.append('apikey', environment.api_key);
   

    var data={
      amount: value.amount,
      comments: value.comments,
      latitute: userCurrenPosition.latitude,
      longitute: userCurrenPosition.longitude,
      remarks: value.comments
    }
    return this.http.post(`${environment.baseUrl}/v1/ym/retailor/move/tobankaccount?transactiontype=${transactiontype}`, data, { headers: headers })
  }
  movetoDistributor(value,distributorType) {
    // let agentId = JSON.parse(localStorage.getItem('currentUser')).data.agentId;
    console.log(value);
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
    var token = localStorage.getItem('wallet-token');
    var md5key=localStorage.getItem('md5key');
    console.log("md5key:::::::::",md5key)
    var checkSum = this.md5Util.getMd5Checksum(value.amount+value.comments+md5key);

    console.log("checkSum::::::::::",checkSum);

    let headers = new HttpHeaders();
    headers = headers.append('authToken', token);
    headers = headers.append('checkSum',checkSum.toString());
    headers = headers.append('apikey', environment.api_key);
   

    var data={
     
      amount: value.amount,
      comment: value.comments,
      distributor:distributorType
     
    }
    return this.http.post(`${environment.baseUrl}/v1/ym/retailor/transfer/todistributor`, data, { headers: headers })
  }
  movetoDistributor2(form,data,motp,ref){
    let headers = new HttpHeaders();
      headers = headers.append("authToken",localStorage.getItem('wallet-token'));
  const body = {
    amount: form.amount,
    comment: form.comments,
    distributor: data
  }
    return this.http.post(`${environment.validate_url}/ym/retailor/transfer/todistributor?motp=${motp}&ref=${ref}`, body,{headers:headers});
  }
  jiomembership(jioNomber) {
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
    var token = localStorage.getItem('wallet-token');
    let headers = new HttpHeaders();
    headers = headers.append('authToken', token);
    headers = headers.append('apikey', environment.api_key);
   
    return this.http.get(`${environment.baseUrl}/v1/ym/retailor/get/jio/membership/details?mobileNumber=${jioNomber}`, { headers: headers })

  }
}
